import { useState, useEffect } from 'react'
import Accordion from '../../../components/accordion'
import { ROUTES } from '../../../constants'
import Link from 'next/link'

const initialAccordionsState = {
  availability: {
    title: 'Where is privauto available?',
    name: 'availability',
    open: false,
  },
  paying: {
    title: 'How do I pay for the vehicle I won?',
    name: 'paying',
    open: false,
  },
  afterSold: {
    title: 'What happens when my vehicle is sold?',
    name: 'afterSold',
    open: false,
  },
  cost: {
    title: 'How much does privauto cost?',
    name: 'cost',
    open: false,
  },
  ifNotSold: {
    title: 'What happens if my vehicle doesn’t sell?',
    name: 'ifNotSold',
    open: false,
  },
  howToVerify: {
    title: 'How do you verify my identity?',
    name: 'howToVerify',
    open: false,
  },
  howInformationUsed: {
    title: 'How is my personal information used?',
    name: 'howInformationUsed',
    open: false,
  },
}

export default function FAQ({
  openedAccordionFromSearch,
  setOpenedAccordionFromSearch,
  accordionsRef,
}) {
  const [accordionsState, setAccordionsState] = useState(initialAccordionsState)

  useEffect(() => {
    if (!!openedAccordionFromSearch) {
      setAccordionsState((prevState) => ({
        ...prevState,
        [openedAccordionFromSearch]: { ...prevState[openedAccordionFromSearch], open: true },
      }))
    }
  }, [openedAccordionFromSearch, accordionsRef])

  const handleAccordionToggle = (name) => {
    setAccordionsState((prev) => ({ ...prev, [name]: { ...prev[name], open: !prev[name].open } }))

    if (!!openedAccordionFromSearch) setOpenedAccordionFromSearch(null)
  }

  return (
    <>
      <h2>Frequently Asked Questions</h2>
      <div className='accordionsContainer'>
        <Accordion
          ref={(ref) => (accordionsRef.current['availability'] = ref)}
          title={accordionsState.availability.title}
          open={accordionsState.availability.open}
          name={accordionsState.availability.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            privauto is currently available in Arkansas and Texas. Additional areas coming
            soon.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['paying'] = ref)}
          title={accordionsState.paying.title}
          open={accordionsState.paying.open}
          name={accordionsState.paying.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            A privauto consultant will be in touch with you to instruct you how to complete
            your purchase.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['afterSold'] = ref)}
          title={accordionsState.afterSold.title}
          open={accordionsState.afterSold.open}
          name={accordionsState.afterSold.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            You will be instructed to bring your vehicle to the nearest concierge location where the
            condition and title of the vehicle will be matched to your supplied description. Once
            the sale is finalized, privauto will transfer the funds directly to your financial
            institution or provide you with a check for the value.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['cost'] = ref)}
          title={accordionsState.cost.title}
          open={accordionsState.cost.open}
          name={accordionsState.cost.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            There are no fees to SELL your vehicle on privauto, it's FREE. <br />
            {`A flat fee of $${process.env.NEXT_PUBLIC_BUY_FEE} will be paid by the buyer regardless of amount the vehicle sells for.`}
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['ifNotSold'] = ref)}
          title={accordionsState.ifNotSold.title}
          open={accordionsState.ifNotSold.open}
          name={accordionsState.ifNotSold.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            Don't worry! privauto lets you list it as many times as you want. We also have a
            fixed “Buy it now” type listing!
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['howToVerify'] = ref)}
          title={accordionsState.howToVerify.title}
          open={accordionsState.howToVerify.open}
          name={accordionsState.howToVerify.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            Our identity verification carried out by{' '}
            <a href='https://trulioo.com' target='_blank'>
              Trulioo.com
            </a>
            , one of the most trusted names in safe and secure identity verification.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['howInformationUsed'] = ref)}
          title={accordionsState.howInformationUsed.title}
          open={accordionsState.howInformationUsed.open}
          name={accordionsState.howInformationUsed.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            Your personal information is only used for the purposes of verifying your identity and
            we do not share or sell it to any other third parties.
          </p>
        </Accordion>
      </div>
      <div className='wrapper flex justifyBetween'>
        <Link legacyBehavior href={ROUTES.BuyerFaq}>
          <div className='buyerSellerFaq buyerFaqImage'>
            <div className='faqContent'>For Buyers</div>
          </div>
        </Link>
        <Link legacyBehavior href={ROUTES.SellerFaq}>
          <div className='buyerSellerFaq sellerFaqImage'>
            <div className='faqContent'>For Sellers</div>
          </div>
        </Link>
      </div>
      <style jsx>{`
        h2 {
          margin: 0 0 2.7rem;
          font-size: 5.4rem;
          line-height: 7.1rem;
        }

        .accordionsContainer {
          :global(.title button) {
            padding: 2.5rem 7rem 2.4rem 2.9rem;
            color: var(--primary-color);
            font-size: 2rem;
          }

          :global(.children) {
            padding: 3.3rem;
            font-size: 1.8rem;
          }
        }

        .wrapper {
          flex-wrap: wrap;
          width: 100%;
          padding-left: 5px;
          padding-right: 5px;
        }

        .buyerSellerFaq {
          width: 600px;
          max-width: 600px;
          height: 240px;
          box-shadow: 0px 3px 6px #00000029;
          border-radius: 10px;
          opacity: 1;
          text-align: center;
          color: #0e77ef;
          font: normal normal bold 44px/58px Red Hat Display;
          cursor: pointer;
          position: relative;
          background-color: var(--secondary-bg-color) !important;
          margin-top: 1.5rem;
        }

        .buyerFaqImage {
          background: transparent url('../../../../images/shopping-cart.svg') 0% 0% no-repeat
            padding-box;
          background-position: center;
        }

        .sellerFaqImage {
          background: transparent url('../../../../images/car.svg') 0% 0% no-repeat padding-box;
          background-position: center;
        }

        .faqContent {
          width: 100%;
          position: absolute;
          bottom: 0;
          text-align: center;
        }

        @media (max-width: 1024px) {
          h2 {
            margin: 0 0 0.9rem;
            text-align: center;
            font-size: 2rem;
            line-height: 2.6rem;
          }

          .accordionsContainer {
            :global(.title button) {
              padding: 1.5rem 7rem 1.5rem 1.8rem;
              font-size: 1.4rem;
            }

            :global(.children) {
              padding: 0.4rem 1rem 0.9rem;
              font-size: 1.4rem;
            }
          }

          .wrapper {
            flex-direction: column;
          }
        }

        @media (max-width: 640px) {
          .buyerSellerFaq {
            width: 100%;
          }
        }
      `}</style>
    </>
  )
}
